export const PERMISSIONS_KEYS = {
  PRESCRIPTION_VIEW: 'PRESCRICAO_CONSULTAR',
  PRESCRIPTION_INSERT: 'PRESCRICAO_INCLUIR',
  PRESCRIPTION_EDIT: 'PRESCRICAO_ATUALIZAR',
  PRESCRIPTION_APPROVE: 'PRESCRICAO_APROVAR_EMEDE',
  PRESCRIPTION_CLIENT_APPROVE: 'PRESCRICAO_APROVAR_CLIENTE',
  PRESCRIPTION_ENTERAL: 'ENTERAL_USAR',
  TRANSCRIPTION_VIEW: 'TRANSCRICAO_CONSULTAR',
  TRANSCRIPTION_INSERT: 'TRANSCRICAO_INCLUIR',
  TRANSCRIPTION_EDIT: 'TRANSCRICAO_ATUALIZAR',
  TRANSCRIPTION_APPROVE: 'TRANSCRICAO_APROVAR',
  SIEVE_VIEW: 'CRIVO_CONSULTAR',
  SIEVE_INSERT: 'CRIVO_INCLUIR',
  SIEVE_EDIT: 'CRIVO_ATUALIZAR',
  SIEVE_DELETE: 'CRIVO_EXCLUIR',
  EXPRESSION_VIEW: 'EXPRESSAO_CONSULTAR',
  EXPRESSION_INSERT: 'EXPRESSAO_INCLUIR',
  EXPRESSION_EDIT: 'EXPRESSAO_ATUALIZAR',
  EXPRESSION_DELETE: 'EXPRESSAO_EXCLUIR',
  RULES_ENGINE_VIEW: 'REGRA_CONSULTAR',
  RULES_ENGINE_INSERT: 'REGRA_INCLUIR',
  RULES_ENGINE_EDIT: 'REGRA_ATUALIZAR',
  RULES_ENGINE_DELETE: 'REGRA_EXCLUIR',
  PARAMETERS_VIEW: 'PARAMETRO_CONSULTAR',
  PARAMETERS_EDIT: 'PARAMETRO_ATUALIZAR',
  PARAMETERS_DELETE: 'PARAMETRO_EXCLUIR',
  PRESCRIPTION_TEMPLATES_VIEW: 'TEMPLATE_CONSULTAR',
  PRESCRIPTION_TEMPLATES_INSERT: 'TEMPLATE_INCLUIR',
  PRESCRIPTION_TEMPLATES_EDIT: 'TEMPLATE_ATUALIZAR',
  CLIENT_VIEW: 'CLIENTE_CONSULTAR',
  CLIENT_EDIT: 'CLIENTE_ATUALIZAR',
  CLIENT_UNIT_VIEW: 'UNIDADE_CLIENTE_CONSULTAR',
  CLIENT_UNIT_INSERT: 'UNIDADE_CLIENTE_INCLUIR',
  CLIENT_UNIT_EDIT: 'UNIDADE_CLIENTE_ATUALIZAR',
  CLIENT_UNIT_DELETE: 'UNIDADE_CLIENTE_EXCLUIR',
  DOCTOR_VIEW: 'MEDICO_CONSULTAR',
  DOCTOR_INSERT: 'MEDICO_INCLUIR',
  DOCTOR_EDIT: 'MEDICO_ATUALIZAR',
  DOCTOR_DELETE: 'MEDICO_EXCLUIR',
  BUSINESS_UNIT_VIEW: 'EMPRESA_CONSULTAR',
  BUSINESS_UNIT_INSERT: 'EMPRESA_INCLUIR',
  BUSINESS_UNIT_EDIT: 'EMPRESA_ATUALIZAR',
  BUSINESS_UNIT_DELETE: 'EMPRESA_EXCLUIR',
  PATIENT_VIEW: 'PACIENTE_CONSULTAR',
  PATIENT_INSERT: 'PACIENTE_INCLUIR',
  PATIENT_EDIT: 'PACIENTE_ATUALIZAR',
  PATIENT_MERGE: 'PACIENTE_AGRUPAR',
  PRODUCT_VIEW: 'PRODUTO_CONSULTAR',
  PRODUCT_INSERT: 'PRODUTO_INCLUIR',
  PRODUCT_EDIT: 'PRODUTO_ATUALIZAR',
  PRODUCT_DELETE: 'PRODUTO_EXCLUIR',
  MATERIAL_VIEW: 'INSUMO_CONSULTAR',
  MATERIAL_INSERT: 'INSUMO_INCLUIR',
  MATERIAL_EDIT: 'INSUMO_ATUALIZAR',
  MATERIAL_DELETE: 'INSUMO_EXCLUIR',
  GROUP_VIEW: 'GRUPO_SUBGRUPO_CONSULTAR',
  GROUP_INSERT: 'GRUPO_SUBGRUPO_INCLUIR',
  GROUP_EDIT: 'GRUPO_SUBGRUPO_ATUALIZAR',
  GROUP_DELETE: 'GRUPO_SUBGRUPO_EXCLUIR',
  PROFILE_VIEW: 'PERFIL_CONSULTAR',
  PROFILE_INSERT: 'PERFIL_INCLUIR',
  PROFILE_EDIT: 'PERFIL_ATUALIZAR',
  PROFILE_DELETE: 'PERFIL_EXCLUIR',
  USER_VIEW: 'USUARIO_CONSULTAR',
  USER_INSERT: 'USUARIO_INCLUIR',
  USER_EDIT: 'USUARIO_ATUALIZAR',
  USER_DELETE: 'USUARIO_EXCLUIR',
  USER_UNIT_ALTER: 'UNIDADE_ALTERAR',
  USER_ACCESS_EMAIL: 'USUARIO_EMAIL_ACESSO',
  USER_DOCS_ANALYSIS: 'USUARIO_ANALISE_DOCUMENTOS',
  TEAM_VIEW: 'TIME_CONSULTAR',
  TEAM_INSERT: 'TIME_INCLUIR',
  TEAM_EDIT: 'TIME_ATUALIZAR',
  TEAM_DELETE: 'TIME_EXCLUIR',
  BAG_MODEL_VIEW: 'BOLSA_COMPART_CONSULTAR',
  BAG_MODEL_INSERT: 'BOLSA_COMPART_INCLUIR',
  BAG_MODEL_EDIT: 'BOLSA_COMPART_ATUALIZAR',
  SPLITTED_BAG_CONFIG: 'BOLSA_COMPART_CONFIG',
  THERAPY_VIEW: 'TERAPIA_CONSULTAR',
  THERAPY_INSERT: 'TERAPIA_INCLUIR',
  THERAPY_EDIT: 'TERAPIA_ATUALIZAR',
  SIMPLE_THERAPY_VIEW: 'TERAPIA_SIMPLIF_CONSULTAR',
  SIMPLE_THERAPY_INSERT: 'TERAPIA_SIMPLIF_INCLUIR',
  SIMPLE_THERAPY_EDIT: 'TERAPIA_SIMPLIF_ATUALIZAR',
  CLINIC_STATES_VIEW: 'ESTCLINICO_CONSULTAR',
  CLINIC_STATES_INSERT: 'ESTCLINICO_INCLUIR',
  CLINIC_STATES_EDIT: 'ESTCLINICO_ATUALIZAR',
  CLINIC_SITUATIONS_VIEW: 'SITCLINICA_CONSULTAR',
  CLINIC_SITUATIONS_INSERT: 'SITCLINICA_INCLUIR',
  CLINIC_SITUATIONS_EDIT: 'SITCLINICA_ATUALIZAR',
  ENTERAL_VIEW: 'ENTERAL_CONSULTAR',
  ENTERAL_INSERT: 'ENTERAL_INCLUIR',
  ENTERAL_EDIT: 'ENTERAL_ATUALIZAR',
  PATIENT_EVOLUTION_REPORT: 'RELATORIO_PACIENTE_EVOLUCAO',
  USERS_REPORT: 'RELATORIO_USUARIOS',
  USED_PRODUCTS_REPORT: 'RELATORIO_PRODUTOS_UTILIZADOS',
  CLIENT_UNITS_REPORT: 'RELATORIO_UNIDADES',
  RULES_REPORT: 'RELATORIO_RESTRICOES',
  ALERTS_PRESCRIPTIONS_REPORT: 'RELATORIO_ALERTAS_PRESCRICOES',
  CLIENT_UNITS_PRODUCTS_REPORT: 'RELATORIO_UNIDADES_PRODUTOS',
  PRESCRIPTOR_PRESCRIPTIONS_REPORT: 'RELATORIO_QTDE_PRESC_PRESCRITOR',
  ADDRESS_PRESCRIPTIONS_REPORT: 'RELATORIO_QTDE_PRESC_ENDERECO',
  PRESCRIPTIONS_MONTH_PDFS: 'PDFS_PRESCRICOES_MES',
  DASHBOARD_ADMIN: 'DASHBOARD_ADMIN',
  MONITORING_PATIENT: 'ACOMPANHA_PACIENTE',
  NOTIFICATION_VIEW: 'NOTIFICACAO_CONSULTAR',
  NOTIFICATION_INSERT: 'NOTIFICACAO_INCLUIR',
  NOTIFICATION_EDIT: 'NOTIFICACAO_ATUALIZAR',
  PENDING_PRESCRIPTION_VIEW: 'PENDENCIA_PRESCRICAO_CONSULTAR',
  PENDING_PRESCRIPTION_EDIT: 'PENDENCIA_PRESCRICAO_ATUALIZAR',
  REQUEST_QUOTE_SHIPPING: 'PROPOSTA_FRETE_SOLICITAR',
  ANALISE_QUOTE_SHIPPING: 'PROPOSTA_FRETE_ANALISAR',
  ANALISE_QUOTE_SHIPPING_VIEW: 'PROPOSTA_FRETE_CONS_ANALISE',
  ADDRESS_ADM_VIEW: 'ENDERECO_ADM_CONSULTAR',
  ADDRESS_ADM_BLOCK: 'ENDERECO_ADM_BLOQUEAR',
  ADDRESS_ADM_UNBLOCK: 'ENDERECO_ADM_DESBLOQUEAR',
  CRM_INSTITUTION_VIEW: 'CRM_INSTITUICAO_CONSULTAR',
  CRM_INSTITUTION_INSERT: 'CRM_INSTITUICAO_INCLUIR',
  CRM_INSTITUTION_EDIT: 'CRM_INSTITUICAO_ALTERAR',
  CRM_INSTITUTION_SYNC_GEOAREA: 'CRM_INSTITUICAO_SINC_AREAGEO',
  CRM_CONTACT_VIEW: 'CRM_CONTATO_CONSULTAR',
  CRM_CONTACT_INSERT: 'CRM_CONTATO_INCLUIR',
  CRM_CONTACT_EDIT: 'CRM_CONTATO_ALTERAR',
  CRM_VISIT_PLANNING_VIEW: 'CRM_AGENDA_VISITA_CONSULTAR',
  CRM_VISIT_PLANNING_INSERT: 'CRM_AGENDA_VISITA_INCLUIR',
  CRM_VISIT_PLANNING_EDIT: 'CRM_AGENDA_VISITA_ALTERAR',
  CRM_VISIT_VIEW: 'CRM_REGISTRO_VISITA_CONSULTAR',
  CRM_VISIT_INSERT: 'CRM_REGISTRO_VISITA_INCLUIR',
  CRM_VISIT_EDIT: 'CRM_REGISTRO_VISITA_ALTERAR', 
  CRM_PLANNING_CYCLE_VIEW: 'CRM_CICLO_PLANEJ_CONSULTAR',
  CRM_PLANNING_CYCLE_EDIT: 'CRM_CICLO_PLANEJ_ALTERAR',
  CRM_DASHBOARD_VIEW: 'CRM_DASHBOARD_CONSULTAR',
  CRM_VISITS_EVOLUTION: 'CRM_DASHBOARD_EVOL_VISITA',
  CRM_INSTITUTION_EVOLUTION: 'CRM_DASHBOARD_EVOL_INSTITUICAO',
  CALENDAR_HOLIDAY_VIEW: 'CALENDARIO_FERIADO_CONSULTAR', 
  CALENDAR_HOLIDAY_EDIT: 'CALENDARIO_FERIADO_ALTERAR', 
  CRM_PLANNER_ITEM_VIEW: 'CRM_AGENDA_ITEM_CONSULTAR',
  CRM_PLANNER_ITEM_INSERT: 'CRM_AGENDA_ITEM_INCLUIR',
  CRM_PLANNER_ITEM_EDIT: 'CRM_AGENDA_ITEM_ALTERAR',

};
